import React, {FC} from "react";
import {Container, InfoText} from "../ui";
import {Image} from "@fluentui/react-northstar";
import getUrl from "../../helpers/images/getUrl";
import clock from "../ui/Icons/clock.svg";


const Timeout: FC = () => {
  return (
    <Container>
      <Image styles={{marginBottom: "20px"}} src={getUrl(clock)} />
      <div style={{fontSize: "20px", fontWeight: "bold"}}>
        Uh-oh!
      </div>
      <InfoText>
        Microsoft Teams seems to be taking longer than normal to respond.
      </InfoText>
      <InfoText>
        Please close this window & the Perkbox sign-in window behind it and <br/> reopen the Perkbox app for Microsoft Teams.
      </InfoText>
    </Container>
  )
}

export default Timeout
